// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nt-0";